<div class="ka-selector">
  <div class="ka-selector-head">
    <p>{{ description }}</p>
    <span class="ka-selection-count"
      >{{ selectedCount }} / {{ maxSelectedKeyActionCount }} 選択中</span
    >
  </div>
  <div class="ka-option-grid" role="group" [attr.aria-label]="ariaLabel">
    @for (option of options; track option.id) {
      <button
        class="ka-option"
        type="button"
        [attr.aria-pressed]="option.selected"
        [attr.aria-disabled]="
          (!option.selected && selectionLimitReached) || readonly
        "
        [disabled]="!readonly && !option.selected && selectionLimitReached"
        (click)="toggle(option)"
      >
        <span class="ka-option-check">
          <svg
            aria-hidden="true"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <path d="m5 12 4 4L19 6" />
          </svg>
        </span>
        <span class="ka-option-copy">
          <strong
            ><span class="ka-no">{{ option.label }}</span
            >{{ option.name }}</strong
          >
          <small>
            {{ scoreCountLabel }}
            <b class="ka-option-score" [class.low]="option.lowScore">{{
              option.averageScoreText
            }}</b>
            / 5
          </small>
        </span>
      </button>
    }
  </div>
</div>
